import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class DewpointAndPressureSensorNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.DewpointAndPressureSensor,
    });
  }
}
